// frontend/src/pages/user/MyTradesPage.tsx
import { useAccount } from 'wagmi'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useMyTrades } from '../../hooks/useMyTrades'
import { TradeRow } from '../../components/p2p/TradeRow'

export function MyTradesPage() {
  const { address } = useAccount()
  const { data, isLoading } = useMyTrades()

  return (
    <div className="max-w-4xl mx-auto space-y-5">
      <header className="space-y-2">
        <Link to="/p2p" className="inline-flex items-center gap-1 text-xs text-dark-500 hover:text-uni-400 transition-colors">
          <ArrowLeft className="w-3 h-3" />
          Volver al intercambio
        </Link>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold text-white">Mis trades</h1>
        <p className="text-sm text-dark-400">Historial de intercambios ejecutados, con tx de ambas chains.</p>
      </header>

      <div className="space-y-3">
        {isLoading ? (
          <div className="rounded-xl border border-dark-800 bg-dark-900/40 p-4 animate-pulse">
            <div className="h-4 bg-dark-800 rounded w-1/3 mb-3" />
            <div className="h-6 bg-dark-800 rounded w-2/3 mb-3" />
            <div className="h-4 bg-dark-800 rounded w-1/2" />
          </div>
        ) : !data || data.length === 0 ? (
          <div className="rounded-xl border border-dashed border-dark-800 bg-dark-900/30 p-10 text-center space-y-2">
            <div className="text-3xl text-dark-700">∅</div>
            <p className="text-sm text-dark-400">Aún no tienes trades ejecutados</p>
            <Link
              to="/p2p"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium bg-uni-500/15 text-uni-400 border border-uni-500/30 hover:bg-uni-500/25 transition-colors"
            >
              Hacer mi primer trade →
            </Link>
          </div>
        ) : (
          data.map((t) => <TradeRow key={t.tradeId} trade={t} myAddress={address ?? ''} />)
        )}
      </div>
    </div>
  )
}
